import {collection, EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";

export class CourseReferenceData extends EntityData<CourseReferenceData> {
    @identifier courseId: number;
    @field name: string;
}

export class CourseData extends EntityData<CourseData> {
    private static COURSE_TYPE: number = 100;
    private static GROUP_TYPE: number = 101;

    public static RESDIARY_MEAL_STATUS_DRINKS: number = 2;
    public static RESDIARY_MEAL_STATUS_STARTER: number = 3;
    public static RESDIARY_MEAL_STATUS_MAIN: number = 4;
    public static RESDIARY_MEAL_STATUS_DESSERT: number = 5;

    public static OPENTABLE_TABLE_STATUS_APPETIZER = "appetizer";
    public static OPENTABLE_TABLE_STATUS_ENTREE = "entree";
    public static OPENTABLE_TABLE_STATUS_DESSERT = "dessert";

    @identifier courseId: number;
    @field name: string;
    @field type: number;
    @field colour: number;
    @field warningTime: number;
    @field resdiary_mealstatus: number;
    @field openTableTableStatus: string;
    @field idx: number;

    @transientField get callAway(): boolean {
        return this.type === CourseData.COURSE_TYPE;
    }

    set callAway(callAway: boolean) {
        this.type = callAway ? CourseData.COURSE_TYPE : CourseData.GROUP_TYPE;
    }

    @transientField get rgbaColour(): string {
        const rgb: number = this.colour & 0xFFFFFF;
        const alpha: number = (this.colour >>> 24) & 0xFF;
        return "#" + ("00000" + rgb.toString(16)).slice(-6) + ("0" + alpha.toString(16)).slice(-2);
    }

    set rgbaColour(rgbaColour: string) {
        const colour: number = Number(rgbaColour.replace("#", "0x"));
        const rgb = colour >>> 8;
        const alpha = colour & 0xFF;
        this.colour = (alpha << 24) | rgb;
    }

    @transientField get warningMinutes(): number {
        return this.warningTime == undefined ? undefined : this.warningTime / 60000;
    }

    set warningMinutes(warningMinutes: number) {
        this.warningTime = warningMinutes == undefined ? undefined : warningMinutes * 60000;
    }
}

export class CourseDefinitionReferenceData extends EntityData<CourseDefinitionReferenceData> {
    @identifier id: number;
    @field name: string;
}

export class CourseDefinitionData extends EntityData<CourseDefinitionData> {
    @identifier id: number;
    @field name: string;
    @collection(CourseData) courses: CourseData[];
}
